module.exports = __webpack_public_path__ + "img/type1_bg.2e5d0e3b.png";